import React from "react";
import { Box } from "@mui/material/";
import { PowerBIEmbed } from "powerbi-client-react";
import PropTypes from "prop-types";
import styles from "./styles";

const TabPanel = ({ reportEmbedConfig, value, index, isCustom, customComponent }) => {
  // powerbi-client validates the config when it embeds and throws ("Invalid
  // parameters" / "Invalid embed URL detected") if the report id or access
  // token is missing. That throw happens inside the embed effect, and the app
  // has no error boundary, so it escapes as an unhandled render error and
  // takes the whole screen. Both are undefined until the token request comes
  // back, and stay undefined if it fails, so only embed once we actually have
  // them.
  const canEmbed = Boolean(reportEmbedConfig?.id && reportEmbedConfig?.accessToken);

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`report-tabpanel-${index}`}
      aria-labelledby={`report-tab-${index}`}
      sx={styles.tabPanel}
    >
      {value !== index ? null : isCustom && customComponent ? (
        <Box sx={{ mt: 2 }}>{customComponent}</Box>
      ) : !canEmbed ? null : (
        <PowerBIEmbed
          embedConfig={reportEmbedConfig}
          eventHandlers={
            new Map([
              ["loaded", () => {}],
              ["rendered", () => {}],
                            [
                                "error",
                                (event) => {
                                    console.log("PowerBI--Err", event.detail);
                                }
                            ]
            ])
          }
          getEmbeddedComponent={(embeddedReport) => {
            window.report = embeddedReport;
          }}
        />
      )}
    </Box>
  );
};

TabPanel.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  reportEmbedConfig: PropTypes.object.isRequired,
  isCustom: PropTypes.bool,
  customComponent: PropTypes.node
};

export default TabPanel;
